import { useRef, useState } from 'react';

// 파일 업로드 공용 드롭존 — 드래그 앤 드롭 또는 클릭하여 파일을 선택할 수 있는 공용 UI.
// 앱 전역의 모든 파일첨부 입력 지점에서 이 컴포넌트를 공통으로 사용한다(인증관리에서 처음 도입).
//
// props
//   currentLabel : 이미 등록되어 있는 파일명(수정 화면에서 "현재: xxx.pdf" 안내용, 선택)
//   fileName     : 방금 선택/드롭한 파일명(선택 후 미리보기용, 단일파일 모드)
//   onFile       : (file: File) => void — 단일파일 모드에서 파일이 선택/드롭되면 호출
//   multiple     : true면 여러 파일을 한 번에 선택/드롭할 수 있다(2026-08 전자메일 첨부에서 추가)
//   fileNames    : 다중파일 모드에서 이미 담긴 파일명 목록(선택, 안내 문구용 — 실제 목록 표시는
//                  호출하는 쪽에서 별도로 렌더링하는 것을 권장)
//   onFiles      : (files: File[]) => void — 다중파일 모드에서 파일이 선택/드롭되면 호출
//   accept       : input accept 속성(선택)
//   style        : 컨테이너에 덧씌울 추가 스타일(선택)
export default function FileDropZone({ currentLabel, fileName, onFile, multiple, fileNames, onFiles, accept, style }) {
  const [isOver, setIsOver] = useState(false);
  const inputRef = useRef(null);
  return (
    <div
      onClick={() => inputRef.current?.click()}
      onDragOver={e => { e.preventDefault(); e.stopPropagation(); setIsOver(true); }}
      onDragLeave={e => { e.preventDefault(); e.stopPropagation(); setIsOver(false); }}
      onDrop={e => {
        e.preventDefault(); e.stopPropagation(); setIsOver(false);
        if (multiple) {
          const files = Array.from(e.dataTransfer.files || []);
          if (files.length) onFiles(files);
        } else {
          const f = e.dataTransfer.files?.[0];
          if (f) onFile(f);
        }
      }}
      style={{
        border: isOver ? '2px dashed #185FA5' : '1px dashed #ccc',
        borderRadius: 8, padding: '14px 12px', textAlign: 'center', cursor: 'pointer',
        background: isOver ? '#EAF3FC' : '#fafafa', marginBottom: 20, fontSize: 13, color: '#666',
        transition: 'background 0.15s, border 0.15s',
        ...style,
      }}>
      <input ref={inputRef} type="file" accept={accept} multiple={!!multiple}
        onChange={e => {
          if (multiple) {
            const files = Array.from(e.target.files || []);
            if (files.length) onFiles(files);
          } else {
            const f = e.target.files?.[0];
            if (f) onFile(f);
          }
          e.target.value = '';
        }}
        // display:none인 input은 일부 브라우저/웹뷰 환경에서 .click()으로 파일선택창이
        // 열리지 않는 경우가 있어(전자메일 첨부에서 확인), 화면에는 보이지 않지만 실제로는
        // 존재하는 방식(1px 크기 + clip)으로 바꿔 어떤 환경에서도 클릭이 확실히 전달되게 한다.
        style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1,
          overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }} />
      {multiple ? (
        fileNames && fileNames.length ? (
          <span style={{ color: '#185FA5', fontWeight: 600 }}>📎 {fileNames.length}개 파일 선택됨(추가로 더 담으려면 다시 드래그하거나 클릭)</span>
        ) : (
          <span>📥 드래그 앤 드롭 또는 클릭하여 선택(여러 파일 가능)</span>
        )
      ) : fileName ? (
        <span style={{ color: '#185FA5', fontWeight: 600 }}>📎 {fileName}</span>
      ) : (
        <span>📥 드래그 앤 드롭 또는 클릭하여 선택{currentLabel ? ` (현재: ${currentLabel})` : ''}</span>
      )}
    </div>
  );
}
